import Controller from './dropdown_controller'

export default class OrganizationDropdownController extends Controller {
  static classes = [
    'targetOpen',
  ]

  declare readonly hasTargetOpenClass: boolean
  declare readonly targetOpenClass: string

  openValueChanged (): void {
    super.openValueChanged()
    this.#updateOpenClasses()
  }

  #updateOpenClasses (): void {
    const elements = this.element.querySelectorAll('[data-open-classes]')
    elements.forEach(element => {
      const openClasses = (element as HTMLElement).dataset.openClasses?.split(' ') || []
      if (this.openValue) {
        openClasses.forEach(className => {
          element.classList.add(className)
        })
      } else {
        openClasses.forEach(className => {
          element.classList.remove(className)
        })
      }
    })
  }
}
